import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React from "react";
import { changeSidebarButtonState } from "../../../dashboard/actions/dashboardSidebarActions";
import UserComponent from "../../../../common/components/UserComponent";
import { fetchOrganizations } from "../../organizations/actions/organizationActions";

import {
  fetchUsersData,
  addUser,
  editUser,
  deleteUserIdData,
  toggleUserLogin,
} from "../../../../common/actions/UserActions";

function AdminComponent(props) {
  return (
    <UserComponent
      userType={"Admin"}
      fetchUsersData={props.fetchUsersData}
      addUser={props.addUser}
      editUser={props.editUser}
      deleteUserIdData={props.deleteUserIdData}
      toggleUserLogin={props.toggleUserLogin}
      usersInfo={props.adminsInfo}
      changeSidebarButtonState={props.changeSidebarButtonState}
      userRole={"admins"}
      userState={"ADMINS_BTN_ACTIVE"}
      netError={props.netError}
      organizations={props.organizations}
      fetchOrganizations={props.fetchOrganizations}
    />
  );
}

function mapStateToProps(state) {
  return {
    adminsInfo: state.adminsInfo.adminsInfo,
    netError: state.adminsInfo.netError,
    organizations: state.organizationsInfo?.organizationsInfo || [],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeSidebarButtonState,
      fetchUsersData,
      addUser,
      editUser,
      deleteUserIdData,
      toggleUserLogin,
      fetchOrganizations,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminComponent);
